import React from 'react';
import moment from 'moment';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import axios from '../../config/axiosInstance';
import Button from '@material-ui/core/Button';
import DataTable from '../../components/DataTable/DataTable';

export class ViewActivities extends React.Component {

    render() {
        const { allActivities } = this.props;

        const Columns = [
            { name: 'customId', label: 'OS' },
            { name: 'dtRegister', label: 'Início' },
            { name: 'updatedOn', label: 'Fim' },
        ];

        return (
            <Paper>
                <Typography style={{ textAlign: 'center' }}>Todas as Atividade</Typography>
                < DataTable
                    rows={
                        this.props.allActivities.map(i => ({
                            id: i.id,
                            customId: i.customId,
                            dtRegister: i.workActivity == null ?
                                (moment(i.dtRegister, 'YYYY-MM-DD HH:mm:ss').locale('pt-br').format('DD/MM/yyyy - HH:mm'))
                                :
                                (moment(i.workActivity.dtRegister, 'YYYY-MM-DD HH:mm:ss').locale('pt-br').format('DD/MM/yyyy - HH:mm')),
                            updatedOn: i.inParentId == null ? 'Em andamento' : moment(i.dtRegister, "YYYY-MM-DD HH:mm:ss").locale("pt-br").format("DD/MM/YYYY - HH:mm"),
                        })) || []
                    }
                    columns={Columns}
                />
            </Paper >
        );
    }
}

export default ViewActivities;